import { DataService } from "../service";
import { UrlConstants } from "../service/serviceConstant";


export class eventService {
  public async getEventlist(data:any, type:any){
    return DataService.get<any>(UrlConstants.URLNEW(`${'urchat/v2/event-v4/geteventsby_userid'}/${data}/${type}`)).then((data) => {
      return data;
    });
  }

  public async createEvent(data:any){
    return DataService.post<any>(UrlConstants.URLNEW('urchat/v2/event-v4/save'),data).then((data) => {
      return data;
    });
  }
  
  public async editEvent(id:any,data:any){
    return DataService.patch<any>(UrlConstants.URLNEW(`${'urchat/v2/event-v4/update'}/${id}`),data).then((data) => {
      return data;
    });
  }
  public async deleteEvent(data:any){
    return DataService.post<any>(UrlConstants.URLNEW('urchat/v2/event-v4/delete'),data).then((data) => {
      return data;
    });
  }

  public async createNote(data:any){
    return DataService.post<any>(UrlConstants.URLNEW('urchat/v2/notev4/create'),data).then((data) => {
      return data;
    });
  }
  public async getNotelist(data:any,type:any){
    return DataService.get<any>(UrlConstants.URLNEW(`${'urchat/v2/notev4/getnotessby_userid'}/${data}/${type}`)).then((data) => {
      return data;
    });
  }
  public async editNote(id:any,data:any){
    return DataService.patch<any>(UrlConstants.URLNEW(`${'urchat/v2/notev4/update'}/${id}`),data).then((data) => {
      return data;
    });
  }
  public async deleteNote(data:any){
    return DataService.post<any>(UrlConstants.URLNEW('urchat/v2/notev4/delete'),data).then((data) => {
      return data;
    });
  }
  public async createTask(data:any){
    return DataService.post<any>(UrlConstants.URLNEW('urchat/v2/task-v4/save'),data).then((data) => {
      return data;
    });
  }

  public async getTasklist(data:any,type:any){
    return DataService.get<any>(UrlConstants.URLNEW(`${'urchat/v2/task-v4/gettasksby_userid'}/${data}/${type}`)).then((data) => {
      return data;
    });
  }
  public async editTask(id:any,data:any){
    return DataService.patch<any>(UrlConstants.URLNEW(`${'urchat/v2/task-v4/edit'}/${id}`),data).then((data) => {
      return data;
    });
  }
  public async deleteTask(data:any){
    return DataService.post<any>(UrlConstants.URLNEW('urchat/v2/task-v4/delete'),data).then((data) => {
      return data;
    });
  }
  public async completeTask(id:any,data:any){
    return DataService.patch<any>(UrlConstants.URLNEW(`${'urchat/v2/task-v4/updateComplete'}/${id}`),data).then((data) => {
      return data;
    });
  }

  public async getTaskByUid(id:string){
    return DataService.get<any>(UrlConstants.URLNEW(`${'urchat/v2/task-v4/gettaskbyUid'}/${id}`)).then((data) => {
      return data;
    });
  }

  public async getEventByUid(id:string){
    return DataService.get<any>(UrlConstants.URLNEW(`${'urchat/v2/event-v4/geteventsbyUid'}/${id}`)).then((data) => {
      return data;
    });
  }

  public async getNoteByUid(id:string){
    return DataService.get<any>(UrlConstants.URLNEW(`${'urchat/v2/notev4/getnotebyUid'}/${id}`)).then((data) => {
      return data;
    });
  }

  public async getCallMeetingBellNotificationList(type:string){
    return DataService.get<any>(UrlConstants.URLNEW(`${'urchat/v3/notification/list'}?type=${type}`)).then((data) => {
      return data;
    });
  }

  public async getCallMeetingBellNotificationRead(id:string){
    return DataService.get<any>(UrlConstants.URLNEW(`${'urchat/v3/notification/read'}?id=${id}`)).then((data) => {
      return data;
    });
  }

  public async getBellNotificationCount(){
    return DataService.get<any>(UrlConstants.URLNEW(`${'/urchat/v3/notification/count'}`)).then((data) => {
      return data;
    });
  }
  public async getSettings(){
    return DataService.get<any>(UrlConstants.URLNEW(`${'urmeet/v2/meetings/get_settings'}`)).then((data) => {
      return data;
    });
  }
  public async saveVideoMeetSetting(data:any){
    return DataService.post<any>(UrlConstants.URLNEW('urmeet/v2/meetings/settings'),data).then((data) => {
      return data;
    });
  }
  public async getBellNotification(){
    return DataService.get<any>(UrlConstants.URLNEW(`${'/urchat/v3/notification/list?type='}`)).then((data) => {
      return data;
    });
  }
  public async getTemporyContactList(){
    return DataService.get<any>(UrlConstants.URLNEW(`${'/urchat/v3/chat/get_user_details'}`)).then((data) => {
      return data;
    });
  }

  public async getASRLangList(){
    return DataService.get<any>(UrlConstants.URLNEW(`${'/urcall/v1/asr/get_languge'}`)).then((data) => {
      return data;
    });
  }
  public async saveBlockUnblock(data:any){
    return DataService.post<any>(UrlConstants.URLNEW('urchat/v2/administration/update_myaccount_user'),data).then((data) => {
      return data;
    });
  }
}